var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{staticClass:"for-margin-top"},[(_vm.storeInfo.policies.length > 0)?_c('p',{staticClass:"about-merchant-policies-privacy text-black"},[_vm._v(" "+_vm._s(_vm.storeInfo.policies)+" ")]):_c('p',{staticClass:"about-merchant-policies-privacy text-black text-center font-weight-bold"},[_vm._v(" لا يوجد ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }